var map = {
	"./bg.jpg": 343,
	"./home-bg-doctor.jpg": 344,
	"./home-bg-patient.jpg": 345,
	"./home_bg_patient_white.jpg": 348,
	"./home_phone_cropped_1.jpg": 349,
	"./phone_en_0.jpg": 214,
	"./phone_en_1.jpg": 360,
	"./phone_en_2.jpg": 361,
	"./phone_hu_0.jpg": 362,
	"./phone_hu_1.jpg": 363,
	"./phone_hu_2.jpg": 364
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 435;



//////////////////
// WEBPACK FOOTER
// ./src/assets nonrecursive \.jpg$
// module id = 435
// module chunks = 2